import React from "react";
import UserNavbar from "../../components/common/UserNavbar";
import UserFooter from "../../components/common/UserFooter";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const UserLayout = (props) => {
  const MessageButton = () => {
    const phoneNumber = "919337233933";

    const openWhatsApp = () => {
      const whatsappUrl = `https://wa.me/${phoneNumber}`;
      window.open(whatsappUrl, "_blank");
    };

    const openDialer = () => {
      window.location.href = `tel:${phoneNumber}`;
    };

    return (
      <>
        <div className="fixed right-4 bottom-4 flex gap-4">
          {/* WhatsApp Button */}
          <button
            className="p-2 rounded-full shadow-lg 
      bg-gradient-to-r from-[#0070a8] to-[#023955] 
      hover:from-[#1e8cbf] hover:to-[#1674a3] 
      text-white hover:scale-110 transition-transform duration-300 ease-in-out"
            onClick={openWhatsApp}
          >
            <FaWhatsapp size={44} className="text-white" />
          </button>

          {/* Call Button */}
          <button
            className="p-2 rounded-full shadow-lg 
      bg-gradient-to-r from-[#0070a8] to-[#023955] 
      hover:from-[#1e8cbf] hover:to-[#1674a3] 
      text-white hover:scale-110 transition-transform duration-300 ease-in-out"
            onClick={openDialer}
          >
            <FaPhoneAlt size={40} className="text-white" />
          </button>
        </div>
      </>
    );
  };

  return (
    <React.Fragment>
      <UserNavbar />
      {props.children}
      <UserFooter />
      <MessageButton />
    </React.Fragment>
  );
};

export default UserLayout;
